import React, { PureComponent } from 'react'
import ReactSwipeEvents from 'react-swipe-events'
import Item from './Item'
import Bullets from './Bullets'
import bemClass from './../../utils/bemClass'
import scroller from './../../utils/scroller'
import api from './../../api'
import './Slider.css'

const cn = bemClass('Slider')

class Slider extends PureComponent {
    timeout = null
    scrollTimeout = null

    state = {
        active: 0,
        items: [],
    }

    getApi = async () => {
        const items = await api('slider')

        this.setState({ items })
    }

    componentDidMount() {
        this.resetTimeout()
    }

    componentWillMount() {
        this.getApi()
    }

    componentWillUnmount() {
        clearTimeout(this.timeout)
        this.timeout = null
    }

    resetTimeout = () => {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(this.increment, 5000)
    }

    setActive = active => this.setState({ active }, this.resetTimeout)

    increment = () => {
        const { items, active } = this.state
        const length = items.length

        return this.setActive((active + 1) % length)
    }

    decrement = () => {
        const { items, active } = this.state
        const length = items.length

        return this.setActive((length + active - 1) % length)
    }

    handleClick = () => scroller(window.innerHeight) // 600 + 126

    renderItems = () => {
        const { items } = this.state

        return items.map((item, key) => (
            <Item
                key={key}
                title={item.title}
                image={item.image}
                subtitle={item.dateString || item.description}
            />
        ))
    }

    render() {
        const { items, active } = this.state
        const length = items.length
        const percent = active * 100
        const tapeStyle = {
            transform: `translate3d(${-1 * percent}%, 0, 0)`,
        }

        return (
            <ReactSwipeEvents
                onSwipedLeft={this.increment}
                onSwipedRight={this.decrement}
            >
                <div className={cn()} onClick={this.handleClick}>
                    <div className={cn('tape')} style={tapeStyle}>
                        {this.renderItems()}
                    </div>
                    <Bullets
                        className={cn('bullets')}
                        length={length}
                        active={active}
                        onSetActive={this.setActive}
                    />
                </div>
            </ReactSwipeEvents>
        )
    }
}

Slider.propTypes = {}

export default Slider



// WEBPACK FOOTER //
// ./src/components/Slider/Slider.jsx